import router from './index.js'
router.beforeEach(
    (to, from, next) => {
        if (to.path) {
            next()
        } else {
            router.push({ path: "/pokemonRandom" })
        }
    }
)


// WEBPACK FOOTER //
// ./src/router/permisson.js